// ═══════════════════════════════════════════════════════════════════
//  modules/projets/TaskHighlightButton.js
//  TaskHighlightButton
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { _highlightSet, getHighlightSet } from "./highlight";

export function TaskHighlightButton({ taskId, token }) {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { getHighlightSet(token).then((set) => setOn(set.has(Number(taskId)))); }, [taskId, token]);

  const toggle = async () => {
    const next = !on;
    setBusy(true);
    try {
      await fetch(`${API_BASE}/api/project/tasks/${taskId}/highlight`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ active: next }),
      });
      setOn(next);
      if (_highlightSet) { next ? _highlightSet.add(Number(taskId)) : _highlightSet.delete(Number(taskId)); }
    } catch {}
    setBusy(false);
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      title={on ? "Retirer de « On y travaille »" : "Mettre en avant sur le Dashboard (résumé IA)"}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 11, fontWeight: 600,
        borderRadius: 6, padding: "4px 10px",
        background: on ? THEME.goldDim : THEME.surface,
        border: `1px solid ${on ? THEME.gold : THEME.border}`,
        color: on ? THEME.gold : THEME.textMuted,
      }}
    >
      {busy ? "…" : on ? "⭐ En avant" : "☆ Mettre en avant"}
    </button>
  );
}
